import { ConfirmDialog } from './confirm-dialog';

/**
 * Confirmarea de delogare.
 *
 * Varianta din shadcn-admin își face singură delogarea, dintr-un store de autentificare
 * al ei. Aici primește `onConfirm`, ca în edinro: sesiunea perfectCRM stă în TanStack
 * Query, iar delogarea trebuie să treacă prin `resetSessionCache` — o a doua sursă de
 * adevăr pentru „cine e logat" ar diverge de prima exact când contează.
 */
type SignOutDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  title?: string;
  desc?: string;
  confirmText?: string;
  className?: string;
};

export function SignOutDialog({
  open,
  onOpenChange,
  onConfirm,
  title = 'Delogare',
  desc = 'Sigur vrei să te deloghezi? Va trebui să te autentifici din nou ca să intri în aplicație.',
  confirmText = 'Delogare',
  className,
}: SignOutDialogProps) {
  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      desc={desc}
      confirmText={confirmText}
      destructive
      handleConfirm={onConfirm}
      className={className ?? 'sm:max-w-sm'}
    />
  );
}
